import { DEFAULT_COUNTRY, PROVINCE_LABELS } from "./constants";

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString("es-AR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export interface IProvinceLabel {
  singular: string;
  plural: string;
}

export const getProvinceLabel = (country?: string): IProvinceLabel =>
  PROVINCE_LABELS[country ?? ""] ?? PROVINCE_LABELS[DEFAULT_COUNTRY];
